/*
 * Copyright (c) 2023. Collabro Limited
 */

import React from "react";
import { Grid, Typography } from "@mui/material";
import AnimatedLogo from "./AnimatedLogo";

const LoadingScreen = () => {
  return (
    <Grid
      item
      container
      xs={12}
      height="90vh"
      alignContent="center"
      textAlign="center"
      spacing={1}
    >
      <Grid item xs={12} justifyContent="center" display="flex">
        <AnimatedLogo />
      </Grid>
      <Grid item xs={12}>
        <Typography>Loading...</Typography>
      </Grid>
    </Grid>
  );
};

export default LoadingScreen;
